import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    manifest: {},
    loadingHeader: false,
    loadingFooter: false,
    loadingMobilePage: false,
    pageManual: null,
    pageMobile: null
  },
  mutations: {
    registerManifest (state, { data }) {
      state.manifest = data
      state.manifest.isLoaded = true
    },
    registerManifestHtml (state, { html, page }) {
      if (page === 'header') {
        state.manifest.extraHeader = html
        if (html) {
          localStorage.setItem('pageExtraHeader', html)
        }
      } else if (page === 'footer') {
        state.manifest.extraFooter = html
        if (html) {
          localStorage.setItem('pageExtraFooter', html)
        }
      } /* else if (page === 'mobile') {
        state.manifest.extraMobilePage = html
        if (html) {
          localStorage.setItem('pageExtraMobile', html)
        }
      } */
    },
    registerLoadingHeader (state, status) {
      state.loadingHeader = status
    },
    registerLoadingFooter (state, status) {
      state.loadingFooter = status
    },
    registerLoadingExtraMobilePage (state, status) {
      state.loadingMobilePage = status
    },
    registerManualPage (state, { html }) {
      if (html) {
        state.pageManual = html
        localStorage.setItem('pageManual', html)
      } else {
        state.pageManual = localStorage.getItem('pageManual')
      }
    },
    registerMobilePage (state, { html }) {
      if (html) {
        state.pageMobile = html
        localStorage.setItem('pageMobile', html)
      } else {
        state.pageMobile = localStorage.getItem('pageMobile')
      }
    }
  },
  actions: {
    downloadHeaderHtmlFromUrl ({ state, commit }) {
      let reject = err => {
        console.warn(err)
        commit('registerLoadingHeader', false)
      }
      commit('registerLoadingHeader', true)
      /* fetch(state.manifest.extraHeader).then(response => {
        response.json().then(html => {
          commit({ type: 'registerHtml', html, isHeader: true })
        }).catch(reject)
      }).catch(reject) */
      Vue.http.get(state.manifest.extraHeader/*, this.completeHttpParams({ headers: {}})*/).then(response => {
        commit({ type: 'registerManifestHtml', html: response.body, page: 'header' })
        commit('registerLoadingHeader', false)
      }).catch(reject)
    },
    downloadFooterHtmlFromUrl ({ state, commit }) {
      console.log('FOOTER? downloadFooterHtmlFromUrl',)
      let reject = err => {
        console.warn(err)
        commit('registerLoadingFooter', false)
      }
      commit('registerLoadingFooter', true)
      Vue.http.get(state.manifest.extraFooter/*, this.completeHttpParams({ headers: {}})*/).then(response => {
        commit({ type: 'registerManifestHtml', html: response.body, page: 'footer' })
        commit('registerLoadingFooter', false)
      }).catch(reject)
    }
    /* downloadExtraPageHtmlFromUrl ({ state, commit }) {
      let reject = err => {
        console.warn(err)
        commit('registerLoadingExtraMobilePage', false)
      }
      commit('registerLoadingExtraMobilePage', true)
      Vue.http.get(state.manifest.extraMobilePage.then(response => {
        commit({ type: 'registerManifestHtml', html: response.body, page: 'mobile' })
        commit('registerLoadingExtraMobilePage', false)
      }).catch(reject)
    } */
  }
})